import React from 'react';

import { WarningOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

interface IProps {
  error?: string | null;
  fontSize?: number;
}

export const WarehouseErrorMarker: React.FC<IProps> = ({ error, fontSize = 20 }) => {
  if (!error) {
    return null;
  }

  return (
    <Tooltip placement="top" title={error}>
      <WarningOutlined style={{ fontSize, color: '#ff4d4f' }} />
    </Tooltip>
  );
};
